import { useDesignSystem } from 'contexts/design-system'
import RefreshButtonEui from './refreshButton.eui'
import RefreshButtonMui from './refreshButton.mui'
import { RefreshButtonProps } from './types'

export type { RefreshButtonProps } from './types'

export default function RefreshButton( props: RefreshButtonProps ): React.ReactElement | null {
	const designSystem = useDesignSystem()

	if ( !props.refetchFunction ) {
		return null
	}

	return designSystem === 'mui'
		? <RefreshButtonMui {...props} />
		: <RefreshButtonEui {...props} />
}
